import { kebabCase } from 'change-case'

/**
 * Converts a raw API icon name to an Iconify tabler name.
 * e.g. 'IconUser' -> 'tabler:user', 'user_check' -> 'tabler:user-check'
 */
export function toTablerIconName(raw: string): string {
  return `tabler:${kebabCase(raw).replace(/^icon-/, '')}`
}
